<template>
  <div>
    <front-page-top-navigation />
    <home-slider />
    <div class="bg-white">
      <tw-container class="py-10 md:py-20 md:text-center max-w-[1360px]" >
        <div class="max-w-[900px] mx-auto">
          <h2>
            100% free to use with zero platform fees. Seriously.
          </h2>
          <p class="md:text-lg pt-4">
            Raise more for your cause with GroupRev's free, zero-fee fundraising platform. Empower your team or community to create personalized fundraising pages, with all proceeds going directly to your bank account.
          </p>
        </div>
      </tw-container>
    </div>
    <div class="bg-gray-100 py-10 md:py-20">
      <tw-container class="flex flex-col gap-14 md:gap-20 max-w-[1360px]">
        <trending-fundraisers />
        <top-fundraiser-pages />
      </tw-container>
    </div>
    <div class="py-4 absolute bottom-0 w-full">
      <grouprev-public-footer />
    </div>
  </div>
</template>

<script>
import HomeSlider from '@/pages/home/home-slider.vue'
import HomeFeaturedCampaigns from '@/pages/home/trending-fundraisers.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import TopNavigation from '@/components/TopNavigation.vue'
import FrontPageTopNavigation from '@/components/FrontPageTopNavigation.vue'
import TrendingCrowdFundraisingCampaigns from '@/pages/home/trending-fundraisers.vue'
import TopFundraisers from '@/pages/home/top-fundraiser-pages.vue'
import TopFundraiserPages from '@/pages/home/top-fundraiser-pages.vue'
import TrendingFundraisers from '@/pages/home/trending-fundraisers.vue'
import GrouprevPublicFooter from '@/components/grouprev-public-footer.vue'

export default {
  name: 'HomePage',
  components: { GrouprevPublicFooter, TrendingFundraisers, TopFundraiserPages,  FrontPageTopNavigation, TwContainer,  HomeSlider },
}
</script>
